const SCROLL_UP_CLASS = 'scroll-up';
const SCROLL_DOWN_CLASS = 'scroll-down';
const SCROLL_TOP_CLASS = 'scroll-top';
const HEADER_ID = 'header';
const HEADER_HEIGHT_PROPERTY = '--header-height';

class ScrollNav {
    constructor() {
        this._header = document.getElementById(HEADER_ID);
        if (this._header) {
            addEventListener('DOMContentLoaded', () => {
                this._headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(HEADER_HEIGHT_PROPERTY));
                this._prevScrollPos = 0;
                this._currScrollPos = 0;
                if (this._currScrollPos === 0) {
                    this._header.classList.add(SCROLL_TOP_CLASS);
                }
                this._run();
            });
        }
    }
    _run() {
        addEventListener('scroll', () => {
            if (scrollY - this._headerHeight >= 0) {
                this._currScrollPos = scrollY - this._headerHeight;

                this._addClassIfScrollingUp();
                this._addClassIfScrollingDown();

                this._prevScrollPos = this._currScrollPos;

                this._header.classList.remove(SCROLL_TOP_CLASS);
            } else {
                this._header.classList.add(SCROLL_TOP_CLASS);
                this._header.classList.remove(SCROLL_UP_CLASS);
                this._header.classList.remove(SCROLL_DOWN_CLASS);
            }
        });
    }
    _addClassIfScrollingUp() {
        if (this._prevScrollPos > this._currScrollPos) {
            this._header.classList.add(SCROLL_UP_CLASS);
        } else {
            this._header.classList.remove(SCROLL_UP_CLASS);
        }
    }
    _addClassIfScrollingDown() {
        if (this._prevScrollPos < this._currScrollPos) {
            this._header.classList.add(SCROLL_DOWN_CLASS);
        } else {
            this._header.classList.remove(SCROLL_DOWN_CLASS);
        }
    }
}

const scrollNav = new ScrollNav();
